exports.PORTUGUESE_TRANSLATE = {
  //! Traduccion Menu
  DATA_MAINTENANCE: "Manutenção de dados",
  DATA_MAINTENANCE_TYPES: "Tipos",
  DATA_MAINTENANCE_HOLDER: "Portadores",
  DATA_MAINTENANCE_OTHER: "Outros dados",
  HOLDERS: "Portadores",
  OFFICES: "Escritórios",
  OFFICE: "Escritório",
  COUNTRIES: "Países",
  COUNTRY: "País",
  CALENDAR: "Agenda",
  LOCATIONS: "Localidades",
  TYPES_OF_DOCUMENTS: "Tipos de documentos",
  SAMPLE_TYPES: "Tipos de amostra",
  SAMPLE_TYPE: "Tipo de amostra",
  MEDICAL_INSTITUTIONS: "Instituições médicas",
  MEDICAL_INSTITUTION: "Instituiçõe médica",
  CLIENTS: "Clientes",
  MEDICAL_SPECIALTIES: "Especialidades médicas",
  SPECIALTY: "Especialidade",
  SPECIALTIES: "Especialidades",
  DOCTORS: "Doutores",
  DOCTOR: "Doutor",
  HEADLINES: "Manchetes",
  WITNESSES: "Testemunhas",
  ETHNIC_ORIGIN: "Origem étnica",
  INDIVIDUALS: "Indivíduos",
  STAGE: "Estágio",
  STAGES: "Estágios",
  TECHNIQUES: "Técnicas",
  TECHNIQUE: "Técnica",
  KINSHIPS: "Parentesco",
  KINSHIP: "Relação",
  TYPES_OF_CLINICAL_ANALYSIS: "Tipos de análises clínicas",
  TYPE_OF_CLINICAL_ANALYSIS: "Tipo de análises clínicas",
  PICK_TYPE_OF_CLINICAL_ANALYSIS: "Selecione um tipo de análise clínica",
  TYPES_OF_PATERNITY_STUDIES: "Tipos de estudos de paternidade",
  TYPE_OF_PATERNITY_STUDY: "Tipo de estudo de paternidade",
  PICK_TYPE_OF_PATERNITY_STUDY: "Selecione um tipo de estudo de paternidade",
  PRODUCTS: "Produtos",
  PRODUCT: "Produto",
  GENETIC_MARKERS: "Marcadores genéticos",
  MARKER: "Marcador genético",
  CLINICAL_ANALYZES: "Análises clínicas",
  CLINICAL_ANALYSIS: "Análise clínica",
  CLINICAL_ANALYSIS_DATA: "Dados de análise clínica",
  CLINICAL_ANALYSIS_SHEET: "Folha de análise clínica",
  SHOW_CLINICAL_ANALYSIS: "Análise aberta",
  LIST: "Lista",
  NEW: "Novo",
  OUTBOX: "Caixa de saída",
  INBOX: "Caixa de entrada",
  CREATE_ANALYSIS_FROM_SPREADSHEET: "Crie análises a partir de planilhas",
  CREATE_STUDIES_FROM_SPREADSHEET: "Criar estudos de panilla",
  IMPORT_RESULTS_FROM_SPREADSHEET: "Importar resultados da planilha",
  CREATE_PROSPECTS_FROM_SPREADSHEET: "Criar prospecto da planilha",
  IMPORT_GENEMAPPER: "Importar arquivo - Genemapper",
  PATERNITY_STUDIES: "Estudos de paternidade",
  PATERNITY_STUDY: "Estudo de paternidade",
  PATERNITY_STUDY_SHEET: "Folha de estudo",
  CALCULATE_PATERNITY: "Calcular paternidade",
  PROSPECTS: "Prospetos",
  PROSPECT: "Prospeto",
  SECURITY: "Segurança",
  TASKS: "Tarefas",
  USER: "Usuário",
  USERS: "Usuários",
  CHANGE_PASSWORD: "Mudança de senha",
  PASSWORD_CHANGE: "Mudança de senha pessoal",
  PASSWORDS_NOT_MATCH: "A chave e sua repetição não coincidem",
  ROLES: "Funções",
  TOOLS: "Ferramentas",
  SYSTEM_PARAMS: "Parâmetros do sistema",
  LOGOUT: "Fechar Sessão do {{value}}",
  NEXT: "Próximo",
  BACK: "Anterior",
  LOGIN: "Pagar em",
  PASSWORD: "Senha",
  CONFIRM_PASSWORD: "Confirmar senha",
  CURRENT_PASSWORD: "Senha atual",
  NEW_PASSWORD: "Nova senha",
  PASSWORD_SPECIFICATIONS:
    "A senha deve conter pelo menos uma maiúscula, uma minúscula, um número e algum símbolo (@, $, !, %, *, ?, &, #)",
  PASSWORD_LENGTH: "O comprimento mínimo da senha é: 8",
  EMAIL: "O email",
  ROLE: "Função",
  EXTRACTION_METHOD: "Método de extração",
  EXTRACTION_METHODS: "Métodos de extração",
  ALLELE_1: "Alelo 1",
  ALLELE_2: "Alelo 2",
  ALLELE_3: "Alelo 3",
  PASSWORD_REQUIRED: "Senha requerida",
  CURRENT_PASSWORD_REQUIRED: "Senha atual necessária",
  EMAIL_REQUIRED: "Email obrigatório",
  NAME_REQUIRED: "Nome requerido",
  COLOR_REQUIRED: "Color requerido",
  COLOR_CONTRAST_INVALID: "Contraste não é suficiente",
  SHORT_NAME_REQUIRED: "Nome abreviado obrigatório",
  LASTNAME_REQUIRED: "Sobrenome obrigatório",
  USERNAME_REQUIRED: "Nome de usuário obrigatório",
  DOCUMENT_TYPE_REQUIRED: "Tipo de documento necessário",
  DOCUMENT_INVALID: "Documento inválido",
  DOCUMENT_INVALID_FORMAT: "Formato de documento inválido",
  DOCUMENT_REQUIRED: "Documento necessário",
  PHONE_REQUIRED: "Requer telefone",
  LOCATION_REQUIRED: "Localidade necessária",
  ADDRESS_REQUIRED: "Endereço obrigatório",
  CODE_REQUIRED: "Código requerido",
  NUMBER_REQUIRED: "Número necessário",
  SERIE_REQUIRED: "Série necessária",
  TITLE_REPORT_REQUIRED: "O título do relatório é obrigatório",
  DEADLINE_REQUIRED: "O prazo é obrigatório",
  DEADLINE_TYPE_REQUIRED: "O tipo de prazo é obrigatório",
  TECHNIQUE_REQUIRED: "A técnica é necessária",
  COORDINATION_TYPE_REQUIRED: "Tipo de coordenação necessária",
  INDIVIDUAL_REQUIRED: "O indivíduo é obrigatório",
  TYPE_ANALYSIS_CLINICAL_REQUIRED: "Tipo de análise clínica necessária",
  TYPE_PATERNITY_STUDY_REQUIRED: "Tipo de paternidade exigida",
  MEDICAL_INSTITUTION_REQUIRED: "Instituição médica necessária",
  DOCTOR_REQUIRED: "Doutor obrigatório",
  UBICATION_REQUIRED: "Local obrigatório",
  MAIN_EXTRACTION_REQUIRED: "Extração principal necessária",
  CLIENT_REQUIRED: "Cliente necessário",
  METHOD_REQUIRED: "Método necessário",
  TACOS_RECEIVED_REQUIRED: "Tacos recebidos necessários",
  PROCESSED_TACOS_REQUIRED: "Tacos processados necessários",
  QUANTITY_REQUIRED: "Quantidade necessária",
  CONCENTRATION_REQUIRED: "Concentração necessária",
  TEAM_REQUIRED: "Equipe necessário",
  BOX_REQUIRED: "Caixa necessária",
  COLUMN_REQUIRED: "Coluna necessária",
  ROW_REQUIRED: "Linha necessária",
  METHODOLOGY_REQUIRED: "Um resultado é necessário",
  RESULT_REQUIRED: "Uma metodologia é necessária",
  INTERPRETATION_REQUIRED: "É necessária uma interpretação",
  CONCLUSION_REQUIRED: "Uma conclusão é necessária",
  SAMPLE_REQUIRED: "Pelo menos uma amostra é necessária",
  SAMPLE_TYPE_REQUIRED: "Pelo menos um tipo de amostra é necessário",
  OFFICE_REQUIRED: "Escritório necessário",
  COMPANY_REQUIRED: "O nome da empresa é obrigatório",
  TRUCKING_NUMBER_REQUIRED: "Número de rastreamento obrigatório",
  ETHNIC_ORIGIN_REQUIRED: "Origem étnica exigida",
  GENDER_REQUIRED: "Sexo biológico necessário",
  TASKS_REQUIRED: "Tarefa(s) necessária(s)",
  SAP_CODE_REQUIRED: "Código SAP necessário",
  SOCIAL_REASON_REQUIRED: "Razão social necessária",
  COUNTRY_REQUIRED: "País necessário",
  PRICE_REQUIRED: "Preço requerido",
  FORMAT_REQUIRED: "Formato requerido",
  FILE_REQUIRED: "O arquivo é necessário para prosseguir",
  DESCRIPTION_REQUIRED: "Descrição necessária",
  NURSE_REQUIRED: "Enfermeira necessária",
  DATE_REQUIRED: "Data necessária",
  DATES_REQUIRED: "Datas requeridas",
  SUPPORTED_FILES_NOT_SELECTED: "Os arquivos suportados não foram selecionados",
  SUPPORTED_FILE_EXTENSION: "Extensão/s de arquivo compatível",
  DETAILS: "Detalhes",
  STUDY_DATA: "Dados de estudo",
  EMPTY_DATA: "Sem dados",
  SELECT_DATA: "Selecione os dados",
  LOCATION_DATA: "Dados de localização",
  TYPE_OF_CLINICAL_ANALYSIS_SEARCH: "A pesquisa é realizada nos seguintes campos: nome, código e série",
  TYPE_OF_PATERNITY_STUDY_SEARCH: "A pesquisa é realizada nos seguintes campos: nome, código e série",
  INDIVIDUAL_SEARCH: "Pesquisar pessoas",
  WITNESS_SEARCH: "Pesquisar testemunha",
  INDIVIDUAL_SEARCH_FIELDS: "A pesquisa é realizada nos seguintes dados: código, nomes, sobrenomes, número de documento, escritório e país",
  WITNESS_SEARCH_FIELDS: "A pesquisa é realizada nos seguintes dados: nomes, sobrenomes, tipo e número de documento",
  MEDICAL_INSTITUTION_SEARCH: "Procure instituições médicas",
  MEDICAL_INSTITUTION_SEARCH_FIELDS: "A pesquisa é realizada nos seguintes dados: id, nome, endereço, país, telefone, e-mail",
  DOCTOR_SEARCH: "Pesquisa de médico",
  DOCTOR_SEARCH_FIELDS: "A pesquisa é realizada nos seguintes dados: nome, documento, matrícula, país",
  NURSE_SEARCH: "Enfermeira Pesquisa",
  NURSE_SEARCH_FIELDS: "A pesquisa é realizada nos seguintes dados: nome, documento",
  SELECT_DOCTOR: "Selecione um médico",
  SELECT_MEDICAL_INSTITUTION: "Selecione uma instituição médica",
  CREATE_NEW_INDIVIDUAL: "Criar novo indivíduo",
  SELECTION_OF_INDIVIDUALS: "Seleção de indivíduos",
  SAMPLE_INPUT: "Entrada de amostra",
  EMPTY_OBSERVATIONS: "Sem observações",
  EMPTY_INDIVIDUAL: "Nenhum indivíduo",
  ALL_DATA: "Todo mundo",
  SAVE: "Guarda",
  ACCEPT: "Aceitar",
  CANCEL: "Cancelar",
  CLOSE: "Fechar",
  FIRST_NAME: "Primeiro nome",
  SECOND_NAME: "Nome do meio",
  FIRST_LASTNAME: "Primeiro apelido",
  SECOND_LASTNAME: "Segundo sobrenome",
  BIRTH_DATE: "Data de nascimento",
  REGISTRATION_DATE: "Data de registro",
  ENTER: "Pagar em",
  EMPTY_DETAILS: "Sem detalhes",
  CLEAN: "Limpar",
  CLEAN_SECTION: "Limpar seção",
  CLEAN_FILTERS: "Filtros limpos",
  SEARCH: "Olhe para",
  AUTOCOMPLETE: "Autocompletar",
  TYPE: "Cara",
  CONFIRMATION: "Confirmação",
  CONFIRM_ACTION: "Você quer confirmar esta ação",
  YES: "Sim",
  NO: "Não",
  SERIE: "Série",
  NUMBER: "Número",
  COPY_NUMBER: "Número de cópia",
  COPY_DATE: "Data de admissão",
  COPY_NUMBER_SMALL: "Nº cópia",
  COPY: "Cópia",
  COPY_NAME: "Cópia",
  RELATIONSHIP: "Relação",
  DELETE: "Retirar",
  EDIT: "Editar",
  DATE: "Encontro",
  HOUR: "Hora",
  START_TIME: "Hora de início",
  END_TIME: "Fim do tempo",
  START_TIME_REQUIRED: "Hora de início necessária",
  END_TIME_REQUIRED: "Hora de término necessária",
  CODE: "Código",
  ORIGIN_CODE: "Código origem",
  DM_CODE: "Código pratique DM",
  LOT: "Lote",
  LOT_MAX_LENGTH: "O lote deve ter no máximo {{ max_length }} caracteres",
  STATUS: "Estado",
  STATUS_ACTIVE:
    "Este registro está ativo, então aparecerá em pesquisas futuras",
  STATUS_INACTIVE:
    "Este registro está inativo, então NÃO aparecerá em pesquisas futuras",
  SHOW: "Assistir",
  IS_FINAL: "É final",
  STAGE_IS_FINAL_REQUIRED: "Você deve marcar pelo menos uma etapa como final",
  SELECT: "Selecionar",
  DOWNLOAD: "Baixar",
  CHANGE_CLIENT: "Mudar de cliente",
  TITLE_REPORT: "Título para o relatório",
  DEADLINE: "Prazo final",
  DAYS: "{{value}} dia/s",
  DEADLINE_TYPE: "Tipo de prazo",
  METHODOLOGIES: "Metodologias",
  METHODOLOGY: "Metodologia",
  INTERPRETATION: "Interpretação",
  CONCLUSION: "Conclusão",
  RESULTS: "Resultados",
  RESULT: "Resultado",
  ADD_RESULT: "Adicionar resultado",
  DEADLINE_TYPE_NORMAL: "Dias em execução",
  DEADLINE_TYPE_BUSSINESS: "Dias úteis",
  DEADLINE_TYPE_OTHER: "Outros",
  DESCRIPTION: "Descrição",
  PROCESSED_TACOS: "Tacos processados",
  TACOS_RECEIVED: "Tacos recebidos",
  QUANTITY: "Quantidade",
  MICROLITERS: "Microlitros",
  CONCENTRATION: "Concentração",
  NANOGRAM_PER_MICROLITER: "Nanograma por microlitro",
  DEVOLUTION_DATE: "Data de retorno",
  METHOD: "Método",
  //! Nuevo estudio de paternidad
  TYPE_OF_STUDY: "Tipo de estudo",
  DATE_OF_ADMISSION: "Data de admissão",
  ADMISSION: "Entrada",
  FROM: "A partir de",
  TO: "Até",
  CLIENT: "Cliente",
  NURSE: "Enfermeiro/a",
  RECORDS: "Antecedentes",
  RECIPIENTS: "Destinatários",
  RECIPIENTS_EMPTY: "Sem destinatários",
  NEW_CLIENT: "Novo cliente",
  SELECT_CLIENT: "Selecione um cliente",
  CLEAR_SELECTION: "Seleção clara",
  CLIENT_SEARCH: "Pesquisa de clientes",
  CLIENT_SEARCH_FIELDS: "A pesquisa é realizada nos seguintes dados: id, nome, razão social, documento, código SAP e país",
  CREATE_NEW_CLIENT: "Criar novo cliente",
  NAME: "Nome",
  ORDER: "Ordem",
  COLOR: "Cor",
  SHORT_NAME: "Nome abreviado",
  GM_NAME: "Nome GM",
  FORMAT: "Formato",
  LASTNAME: "Sobrenome",
  USERNAME: "Nome de usuário",
  SOCIAL_REASON: "Razão social",
  SAP_CODE: "Código SAP",
  CURRENCY: "Moeda",
  PRICE: "Preço",
  DOLLAR: "Dólar",
  LOCAL_CURRENCY: "Moeda local",
  DOCUMENT_TYPE: "Tipo de documento",
  DOCUMENT: "Documento",
  PROFESSIONAL_LICENSE: "Licença profissional",
  PHONE: "Telefone",
  ADDRESS: "Endereço",
  DEVOLUTION_ADDRESS: "Endereço de devolução",
  LOCATION: "Localização",
  UBICATION: "Localização",
  TEAM: "Equipe",
  BOX: "Caixa",
  ROW: "Linha",
  COLUMN: "Coluna",
  ORIGIN: "Origem",
  MAIN_EXTRACTION: "Extração principal",
  VALUE: "Valor",
  INDIVIDUAL_INFORMATION: "Informação individual",
  NURSE_INFORMATION: "Informação da enfermeira",
  CONTACT_INFORMATION: "Informações de contato",
  YOU_CONTACT_INFORMATION: "Informação de contato",
  CLIENT_INFORMATION: "Informação ao cliente",
  COMPLETE_INFORMATION: "Informação completa",
  ASSIGN_PROFILES: "Atribuição de perfil a indivíduos",
  IMPORT_PROFILES: "Perfis de importação",
  CONTACT_NAME: "Nome de contato",
  CONTACT_PHONE: "Telefone de contato",
  CONTACT_EMAIL: "Email de contato",
  OBSERVATION: "Observação",
  OBSERVATIONS: "Observações",
  OFFICE_DATA: "Dados do escritório",
  STAGE_DATA: "Dados de estágio",
  TECHNIQUE_DATA: "Dados de técnica",
  TYPE_OF_CLINICAL_ANALYSIS_DATA: "Dados do tipo de análise clínica",
  TYPE_OF_PATERNITY_STUDY_DATA: "Dados de tipo de estudo de paternidade",
  POSTAL_CODE: "Código postal",
  ENTER_INDIVIDUALS_FROM_THE_BOTTOM: "Insira os indivíduos da parte inferior",
  ADD_INDIVIDUALS: "Adicionar indivíduos",
  ADD_INDIVIDUAL: "Adicionar indivíduo",
  INDIVIDUAL: "Individual",
  INSTITUTION: "Instituição",
  NEW_INDIVIDUAL: "Novo indivíduo",
  GENDER: "Sexo biológico",
  GENDERS: "Sexos biológicos",
  COORDINATION_TYPE: "Tipo de coordenação",
  COORDINATION_TYPES: "Tipos de coordenação",
  NURSES: "Enfermeiros",
  APPOINTMENT_SECTOR: "Setores de agendamento",
  APPOINTMENT_SECTORS: "Sectores de agendamento",
  TASK_NAME: "Nome tarefa",
  ADD_TRACE: "Adicionar traço",
  ADD_SAMPLE: "Adicionar amostra",
  ADD_SAMPLES: "Adicionar amostras",
  SAMPLE_DATA: "Dados de amostra",
  EXTRACTION_DATE: "Data de extração",
  TYPE_OF_SAMPLE: "Tipo de amostra",
  EXTRACTIONIST: "Extracionista",
  EXTRACTIONIST_DATA: "Dados extracionistas",
  EXTRACTIONIST_NAME: "Nome extracionista",
  EXTRACTIONIST_DOCUMENT: "Documento extracionista",
  EXTRACTIONIST_DOCUMENT_TYPE: "Tipo de documento de extração",
  WITHOUT_EXTRACTIONIST: "Nenhum extrativista associado",
  WITNESS_DATA: "Dados de testemunhas",
  USER_DATA: "Dados do usuário",
  ROLE_DATA: "Dados da função",
  GENDER_DATA: "Dados da sexo biológico",
  COORDINATION_TYPE_DATA: "Dados do tipo de coordenação",
  SPECIALTY_DATA: "Dados de especialidade",
  DOCTOR_DATA: "Dados do médico",
  COUNTRY_DATA: "Dados do país",
  KINSHIP_DATA: "Dados de parentesco",
  MEDICAL_INSTITUTION_DATA: "Dados da instituição médica",
  APPOINTMENT_SECTOR_DATA: "Dados de setores de agendamento",
  PRODUCT_DATA: "Datas do produto",
  SAMPLE_TYPE_DATA: "Dados do tipo de amostra",
  DOCUMENT_TYPE_DATA: "Dados do tipo de documento",
  MARKER_DATA: "Dados do marcador",
  ETHNIC_ORIGIN_DATA: "Dados de etnia",
  PROSPECT_DATA: "Informações do cliente potencial",
  EXTRACTION_METHOD_DATA: "Dados do método de extração",
  NEW_APPOINTMENT_SECTOR: "Novo setor de agendamento",
  NEW_WITNESS: "Nova testemunha",
  NEW_OFFICE: "Novo escritório",
  NEW_STAGE: "Novo estágio",
  NEW_TECHNIQUE: "Nova técnica",
  NEW_TYPE_ANALYSIS_CLINICAL: "Novo tipo de análise clínica",
  NEW_USER: "Novo usuário",
  NEW_PATERNITY_STUDIE: "Novo estudo de paternidade",
  NEW_CLINICAL_ANALYSIS: "Nova análise clínica",
  NEW_ROLE: "Nova função",
  NEW_LOCATION: "Nova localização",
  NEW_GENDER: "Novo sexo biológico",
  NEW_NURSE: "Nova enfermeira",
  NEW_COORDINATION_TYPE: "Novo tipo de coordenação",
  NEW_SPECIALTY: "Nova especialidade",
  NEW_DOCTOR: "Novo médico",
  NEW_COUNTRY: "Novo país",
  NEW_KINSHIP: "Novo parentesco",
  NEW_MEDICAL_INSTITUTION: "Nova instituição médica",
  NEW_ETHNIC_ORIGIN: "Nova origem étnica",
  NEW_PRODUCT: "Novo produto",
  NEW_TYPE_PATERNITY_STUDY: "Novo tipo de estudo de paternidade",
  NEW_SAMPLE_TYPE: "Novo tipo de amostra",
  NEW_DOCUMENT_TYPE: "Novo tipo de documento",
  NEW_MARKER: "Novo marcador",
  NEW_PROSPECT: "Novo cliente em potencial",
  NEW_EXTRACTION_METHOD: "Novo método",
  WITNESS: "Testemunha",
  WITNESS_NAME: "Nome da testemunha",
  WITNESS_LASTNAME: "Sobrenome de testemunha",
  WITNESS_DOCUMENT: "Documento testemunha",
  WITNESS_EMAIL: "E-mail de testemunha",
  WITNESS_ADDRESS: "Endereço da testemunha",
  WITNESS_PHONE: "Telefone testemunha",
  WITHOUT_WITNESS: "Sem testemunha associada",
  THE_SAMPLES_ENTERED_WILL_BE_DISPLAYED_HARA:
    "As amostras inseridas serão exibidas aqui",
  YOU_MUST_SELECT_AT_LEAST_TWO_INDIVIDUALS:
    "Você deve selecionar pelo menos dois indivíduos",
  ALL_INDIVIDUALS_MUST_HAVE_AN_ASSOCIATED_RELATIONSHIP:
    "Todos os indivíduos devem ter um relacionamento associado",
  THERE_MUST_BE_TWO_DIFFERENT_TYPES_OF_RELATIONSHIPS:
    "Deve haver dois tipos diferentes de relacionamento",
  THE_INDIVIDUAL_MUST_HAVE_A_FIRST_NAME:
    "O indivíduo deve ter um primeiro nome",
  THE_INDIVIDUAL_MUST_HAVE_A_FIRST_LASTNAME:
    "O indivíduo deve ter um primeiro sobrenome",
  THE_INDIVIDUAL_MUST_HAVE_A_TYPE_OF_DOCUMENT:
    "O indivíduo deve ter um tipo de documento",
  THE_INDIVIDUAL_MUST_HAVE_A_DOCUMENT: "O indivíduo deve ter um documento",
  THE_INDIVIDUAL_MUST_HAVE_A_GENDER: "O indivíduo deve ter um sexo biológico",
  THE_INDIVIDUAL_MUST_HAVE_A_ETHNIC_ORIGIN: "Indivíduo deve ter origem étnica",
  THE_INDIVIDUAL_MUST_HAVE_A_ADDRESS: "A pessoa deve ter um endereço",
  THE_INDIVIDUAL_MUST_HAVE_A_LOCATION: "O indivíduo deve ter uma localidade",
  THERE_IS_ALREADY_AN_INDIVIDUAL_WITH_THAT_DOCUMENT:
    "Já existe um indivíduo com aquele documento",
  SELECT_A_WITNESS_OR_ENTER_A_NEW_ONE:
    "Selecione uma testemunha ou insira uma nova",
  ENTER_A_MEANS_OF_CONTACT_FOR_THE_WITNESS:
    "Insira um meio de contato para a testemunha",
  ENTER_THE_WITNESS_DOCUMENT: "Insira o documento testemunha",
  ENTER_THE_WITNESS_LOCATION: "Digite a localização da testemunha",
  ENTER_THE_WITNESS_ADDRESS: "Digite o endereço da testemunha",
  SELECT_A_DOCUMENT_TYPE_FOR_THE_WITNESS:
    "Selecione um tipo de documento para a testemunha",
  ENTER_THE_LAST_NAME_OF_THE_WITNESS: "Digite o sobrenome da testemunha",
  ENTER_THE_NAME_OF_THE_WITNESS: "Digite o nome da testemunha",
  ENTER_THE_EXTRACTIONIST_DOCUMENT: "Digite o documento do extrativista",
  ENTER_THE_TYPE_OF_DOCUMENT_OF_THE_EXTRACTIONIST:
    "Digite o tipo de documento do extrativista",
  ENTER_THE_NAME_OF_THE_EXTRACTIONIST: "Insira o nome do extrativista",
  PICK_AN_INDIVIDUAL: "Escolha um indivíduo",
  PICK_NURSE: "Escolha uma enfermeira",
  CHOOSE_A_SAMPLE_TYPE: "Escolha um tipo de amostra",
  SAMPLE_COORDINATION: "Coordenação de coleta de amostra",
  SAMPLE_TYPE_ALREADY_EXISTS: "Um tipo de amostra com esse nome já existe",

  PATERNITY_STUDIES_LIST_EMPTY:
    "No momento não temos nenhum estudo de paternidade registrado",
  CLINICAL_ANALYSIS_LIST_EMPTY:
    "No momento não temos nenhuma análise registrada",
  PATERNITY_STUDIES_LIST_INBOX_EMPTY:
    "No momento não há estudos de paternidade enviados para seu escritório",
  PATERNITY_STUDIES_LIST_OUTBOX_EMPTY:
    "No momento, seu escritório não enviou nenhum estudo de paternidade para outro escritório",
  CLINICAL_ANALYSIS_LIST_INBOX_EMPTY:
    "No momento não há análises clínicas enviadas para o seu consultório",
  CLINICAL_ANALYSIS_LIST_OUTBOX_EMPTY:
    "Neste momento o seu consultório não enviou nenhuma análise clínica para outro consultório",
  WITNESS_LIST_EMPTY: "No momento não temos nenhuma testemunha registrada",
  OFFICES_LIST_EMPTY: "No momento não temos nenhuma sede",
  STAGES_LIST_EMPTY: "No momento não temos nenhuma etapa cadastrada",
  TECHNIQUES_LIST_EMPTY: "No momento não temos nenhuma técnica registrada",
  TYPES_ANALYSIS_CLINICAL_LIST_EMPTY:
    "No momento não temos nenhum tipo de análise clínica cadastrada",
  INDIVIDUALS_LIST_EMPTY: "No momento não temos pessoas cadastradas",
  CLINICAL_ANALYSIS_LIST_EMPTY_INDIVIDUAL:
    "No momento não temos nenhuma análise clínica associada a este indivíduo",
  SPECIALTIES_LIST_EMPTY_DOCTOR:
    "No momento o médico não possui nenhuma especialidade médica",
  USERS_LIST_EMPTY: "No momento não temos nenhum usuário cadastrado",
  METHODOLOGIES_LIST_EMPTY: "Nenhuma metodologia atribuída",
  RESULTS_LIST_EMPTY: "Nenhum resultado atribuído",
  ROLES_LIST_EMPTY: "No momento não temos nenhuma função registrada",
  USER_OFFICES_LIST_EMPTY: "Sem escritórios atribuídos",
  CLIENTS_LIST_EMPTY: "No momento não temos nenhum cliente cadastrado",
  LOCATIONS_LIST_EMPTY: "No momento não temos nenhum local cadastrado",
  GENDERS_LIST_EMPTY: "No momento não temos nenhum sexo biológico cadastrado",
  APPOINTMENT_SECTOR_LIST_EMPTY: "No momento não temos nenhum setor cadastrado",
  COORDINATION_TYPES_LIST_EMPTY: "No momento não temos nenhum tipo cadastrado",
  SPECIALTIES_LIST_EMPTY:
    "No momento não temos nenhuma especialidade registrada",
  DOCTORS_LIST_EMPTY: "No momento não temos médico cadastrado",
  NURSES_LIST_EMPTY: "No momento não temos enfermeiro/ra cadastrado",
  COUNTRIES_LIST_EMPTY: "No momento não temos nenhum país registrado",
  KINSHIPS_LIST_EMPTY: "No momento não temos nenhuma relação registrada",
  MEDICAL_INSTITUTIONS_LIST_EMPTY:
    "No momento não temos nenhuma instituição médica registrada",
  PRODUCTS_LIST_EMPTY: "No momento não temos nenhum produto registrado",
  TYPES_PATERNITY_STUDY_LIST_EMPTY:
    "No momento não temos nenhum tipo de estudo de paternidade registrado",
  ETHNIC_ORIGINS_LIST_EMPTY:
    "No momento não temos nenhuma origem étnica registrada",
  SAMPLE_TYPES_LIST_EMPTY:
    "No momento não temos nenhum tipo de amostra cadastrada",
  MARKERS_LIST_EMPTY:
    "No momento não temos nenhum marcador genético registrado",
  DOCUMENT_TYPES_LIST_EMPTY:
    "No momento não temos nenhum tipo de documento registrado",
  TASKS_LIST_EMPTY: "No momento não temos tarefas no sistema",
  PROSPECTS_LIST_EMPTY:
    "No momento não temos clientes em potencial cadastrados",
  EXTRACTION_METHODS_LIST_EMPTY:
    "No momento não temos métodos de extração registrados",
  SYSTEM_PARAMS_LIST_EMPTY: "No momento não temos parâmetros cadastrados",
  INDIVIDUALS_LIST_EMPTY_WITH_FILTERS:
    "Nenhum indivíduo encontrado com esse filtro",
  PATERNITY_STUDIES_LIST_EMPTY_WITH_FILTERS:
    "Nenhum estudo de paternidade foi encontrado com esse filtro",
  CLINICAL_ANALYSIS_LIST_EMPTY_WITH_FILTERS:
    "Nenhuma análise encontrada nesse filtro",
  WITNESS_LIST_EMPTY_WITH_FILTERS:
    "Nenhuma testemunha foi encontrada com esse filtro",
  OFFICES_LIST_EMPTY_WITH_FILTERS:
    "Nenhum escritório foi encontrado com esse filtro",
  STAGES_LIST_EMPTY_WITH_FILTERS: "Nenhum estágio encontrado com esse filtro",
  TECHNIQUES_LIST_EMPTY_WITH_FILTERS:
    "Nenhuma técnica encontrada com esse filtro",
  TYPES_ANALYSIS_CLINICAL_LIST_EMPTY_WITH_FILTERS:
    "Nenhum tipo de análises clínicas encontrado com esse filtro",
  USERS_LIST_EMPTY_WITH_FILTERS: "Nenhum usuário encontrado com esse filtro",
  ROLES_LIST_EMPTY_WITH_FILTERS: "Nenhuma função encontrada com esse filtro",
  CLIENTS_LIST_EMPTY_WITH_FILTERS: "Nenhum cliente encontrado com esse filtro",
  LOCATIONS_LIST_EMPTY_WITH_FILTERS:
    "Nenhum local foi encontrado com esse filtro",
  GENDERS_LIST_EMPTY_WITH_FILTERS: "Nenhum sexo biológico encontrado com esse filtro",
  APPOINTMENT_SECTORS_LIST_EMPTY_WITH_FILTERS:
    "Nenhum setor encontrado com esse filtro",
  COORDINATION_TYPES_LIST_EMPTY_WITH_FILTERS:
    "Nenhum tipo encontrado com esse filtro",
  SPECIALTIES_LIST_EMPTY_WITH_FILTERS:
    "Nenhuma especialidade encontrada com esse filtro",
  DOCTORS_LIST_EMPTY_WITH_FILTERS: "Nenhum médico encontrado com esse filtro",
  NURSES_LIST_EMPTY_WITH_FILTERS:
    "Nehum enfermeiro/ra encontrado com esse filtro",
  COUNTRIES_LIST_EMPTY_WITH_FILTERS: "Nenhum país com esse filtro encontrado",
  KINSHIPS_LIST_EMPTY_WITH_FILTERS:
    "Nenhum relacionamento encontrado com esse filtro",
  MEDICAL_INSTITUTIONS_LIST_EMPTY_WITH_FILTERS:
    "Nenhuma instituição médica encontrada com esse filtro",
  PRODUCTS_LIST_EMPTY_WITH_FILTERS: "Nenhum produto encontrado com esse filtro",
  TYPES_PATERNITY_STUDY_LIST_EMPTY_WITH_FILTERS:
    "Nenhum tipo de estudo de paternidade encontrado com esse filtro",
  ETHNIC_ORIGINS_LIST_EMPTY_WITH_FILTERS:
    "Nenhuma origem étnica encontrada com esse filtro",
  SAMPLE_TYPES_LIST_EMPTY_WITH_FILTERS:
    "Nenhum tipo de amostra encontrado com esse filtro",
  DOCUMENT_TYPES_LIST_EMPTY_WITH_FILTERS:
    "Nenhum tipo de documento encontrado com esse filtro",
  MARKERS_LIST_EMPTY_WITH_FILTERS:
    "Nenhum marcador genético encontrado com esse filtro",
  TASKS_LIST_EMPTY_WITH_FILTERS:
    "Nenhuma tarefa foi encontrada com esse filtro",
  PROSPECTS_LIST_EMPTY_WITH_FILTERS: "Nenhum lead encontrado com esse filtro",
  EXTRACTION_METHODS_LIST_EMPTY_WITH_FILTERS:
    "Nenhum método de extração encontrado com esse filtro",
  SYSTEM_PARAMS_LIST_EMPTY_WITH_FILTERS:
    "Nenhum parâmetro encontrado com esse filtro",
  TRANSPORT_EMPTY: "Atualmente, esta análise clínica não está em transporte",
  ADVANCED_FILTERS: "Filtros avançados",
  CURRENT_STAGE: "Estágio atual",
  GROUP_TASKS: "Tarefas de grupo",
  SAMPLING_VISITS: "Amostra tirando visitas",
  SELECTED_STUDIES: "Estudos selecionados",
  SELECTED_ANALYZES: "Análises selecionadas",
  SELECTED_PROSPECTS: "Clientes em potencial selecionados",
  FILTER_STUDIES: "Filtre estudos",
  FILTER_ANALYZES: "Análises de filtro",
  FILTER_WITNESSES: "Testemunhas de filtro",
  FILTER_OFFICES: "Filtre escritórios",
  FILTER_STAGES: "Filtre estágios",
  FILTER_TECHNIQUES: "Filtre técnicas",
  FILTER_TYPES_ANALYSIS_CLINICAL: "Filtre tipos de análises clínicas",
  FILTER_INDIVIDUALS: "Filtre indivíduos",
  FILTER_USERS: "Filtre usuários",
  FILTER_ROLES: "Filtre funções",
  FILTER_CLIENTS: "Clientes de filtro",
  FILTER_LOCATIONS: "Filtrar locais",
  FILTER_GENDERS: "Filtrar sexo biológico",
  FILTER_COORDINATION_TYPES: "Filtrar tipos de coordenação",
  FILTER_SPECIALTIES: "Filtrar especialidades",
  FILTER_DOCTORS: "Filtrar médicos",
  FILTER_NURSES: "Filtrar enfermeiros",
  FILTER_COUNTRIES: "Filtrar países",
  FILTER_KINSHIP: "Filtrar parentesco",
  FILTER_MEDICAL_INSTITUTIONS: "Filtrar instituições médicas",
  FILTER_ETHNIC_ORIGINS: "Filtrar origens étnicas",
  FILTER_PRODUCTS: "Filtrar produtos",
  FILTER_TYPES_PATERNITY_STUDY: "Filtrar tipos de estudos de paternidade",
  FILTER_SAMPLE_TYPES: "Filtrar tipos de amostra",
  FILTER_DOCUMENT_TYPES: "Filtrar tipos de documentos",
  FILTER_MARKERS: "Marcadores de filtro",
  FILTER_TASKS: "Filtrar tarefas",
  FILTER_PROSPECTS: "Filtrar clientes em potencial",
  FILTER_EXTRACTION_METHODS: "Filtrar métodos",
  FILTER_SYSTEM_PARAMS: "Parâmetros de filtro",
  FILTER_APPOINTMENT_SECTOR: "Filtrar setores",
  STUDY_CODE: "Código de estudo",
  STUDY_NUMBER: "Número do estudo",
  SITUATION: "Situação",
  STATE: "Estado",
  PROMISED_DELIVERY: "Data prometida",
  TECHNIQUE_SELECTED: "Técnica selecionada",
  STUDY_TYPE_SELECTED: "Tipo de estudo selecionado",

  SELECT_INDIVIDUAL: "Selecione um indivíduo",
  SELECT_RELATIONSHIP: "Selecione um relacionamento",
  SELECT_SAMPLE_TYPE: "Selecione um tipo de amostra",
  SELECT_WITNESS: "Selecione uma testemunha",
  SELECT_STAGE: "Selecione um estágio",
  SELECT_STAGES: "Selecione um ou mais estágios",
  SELECT_TASK: "Selecione a tarefa",
  SELECT_ALL_PAGE: "Selecione a página inteira",
  ENTER_DETAIL: "Insira um detalhe",
  ENTER_OBSERVATION_TRACEABILITY: "Insira uma observação para o traço",
  OBSERVATION_TRACEABILITY_MAX_LENGTH: "O comentário deve ter no máximo {{ max_length }} caracteres",
  STUDY: "Estude",
  SAMPLES: "Amostras",
  TRANSPORT: "Transporte",
  TRACEABILITY: "Rastreabilidade",
  ATTACHMENTS: "Anexos",
  ATTACH_FILES: "Anexar arquivos",
  PICTURE: "Foto",
  FOOTPRINT: "Pegada {{value}}",
  SEND_OTHER_OFFICE: "Enviar para outro escritório",
  GENERATE_REPORTS: "Gerar Relatório",
  EXPORT_REPORTS: "Lista de exportação",
  SEND: "Enviar",
  PROCESS: "Processo",
  CHECK_VISITS: "Verifique o resumo das visitas",
  TAKE_VISITS_REPORT: "Relatório de visita",
  CHANGE_STAGE: "Mudança de estágio",
  CREATE_PATERNITY_OR_ANALYZES: "Criar análise ou paternidade",
  CHANGE_STAGE_MESSAGE_PATERNITY_STUDIES:
    "Os estudos de paternidade mudarão seu estágio para",
  CHANGE_STAGE_MESSAGE_CLINICAL_ANALYSIS:
    "As análises clínicas mudarão de estágio para",
  CHANGE_STAGE_MESSAGE_PROSPECTS:
    "Os clientes em potencial mudarão de estágio para",
  CHANGE_CREATE_ANALYZES_OR_STUDIES_PROSPECTS:
    "Tem certeza que deseja criar análises ou paternidades",
  CHANGE_CREATE_ANALYZES_OR_STUDIES_PROSPECTS_MESSAGE:
    "Um estudo de paternidade ou análise clínica será criado para cada cliente selecionado",
  PRINT_LABELS: "Imprimir etiquetas",
  PRINTER: "Impresora",
  FINISH_STUDIES: "Concluir estudos",
  FINISH_ANALYZES: "Terminar as análises",
  RECEIVE_SAMPLES: "Receber amostras",
  SELECT_STAGE_GROUP_TASK: "Selecione o estágio a ser associado aos estudos",
  SELECT_STAGE_GROUP_TASK_MESSAGE: "Você deve selecionar um estágio",
  SELECT_OFFICE_GROUP_TASK: "Selecione o escritório de destino",
  SELECT_SHIPPING_DETAILS_GROUP_TASK: "Selecione os detalhes de envio",
  SELECT_OFFICES: "Selecionar escritório(s)",
  SELECT_OFFICE: "Selecionar escritório",
  SELECT_ROLE: "Selecionar função",
  SELECT_SPECIALTY: "Selecione a especialidade",
  SELECT_SPECIALTIES: "Selecione especialidade(s)",
  SHIPPING_COMPANY_NAME: "Nome da empresa de transporte",
  TRACKING_NUMBER: "Número de rastreio",
  //! Mensajes
  YOU_MUST_FILL_IN_ALL_FIELDS: "Você deve preencher todos os campos",
  CONFIRM_DELETE_PATERNITY_STUDY:
    "Tem certeza que deseja excluir o estudo de paternidade",
  CONFIRM_DELETE_PATERNITY_STUDY_MESSAGE:
    "Observe que você não verá o estudo de paternidade no sistema novamente, mas manteremos uma cópia de seus dados",
  CONFIRM_DELETE_CLINICAL_ANALYSIS:
    "Tem certeza que deseja excluir a análise clínica",
  CONFIRM_DELETE_CLINICAL_ANALYSIS_MESSAGE:
    "Por favor, note que você não verá a análise novamente no sistema, mas manteremos uma cópia de seus dados",
  CONFIRM_DELETE_INDIVIDUAL_FROM_PATERNITY_STUDY:
    "Você com certeza deseja remover o indivíduo",
  CONFIRM_DELETE_INDIVIDUAL_FROM_PATERNITY_STUDY_MESSAGE:
    "Caso o indivíduo mantenha amostras associadas, elas também serão retiradas do estudo de paternidade.",
  CONFIRM_DELETE_SAMPLE: "Tem certeza que deseja deletar a amostra",
  CONFIRM_DELETE_SAMPLE_MESSAGE:
    "A amostra do estudo de paternidade será completamente removida",
  CONFIRM_DELETE_SAMPLE_CLINICAL_MESSAGE:
    "A amostra será completamente removida da análise clínica",
  CONFIRM_DELETE_TRACEABILITY: "Você com certeza deseja remover o traço",
  CONFIRM_DELETE_TRACEABILITY_MESSAGE:
    "O vestígio do estudo de paternidade será removido",
  CONFIRM_DELETE_TRACEABILITY_CLINICAL_MESSAGE:
    "O traço será removido da análise clínica",
  CONFIRM_DELETE_TRACEABILITY_PROSPECT:
    "O traço do cliente em potencial será removido",
  CONFIRM_DELETE_ATTACHMENT: "Tem certeza que deseja excluir o anexo",
  CONFIRM_DELETE_ATTACHMENT_MESSAGE:
    "O anexo do estudo de paternidade será removido",
  CONFIRM_DELETE_ATTACHMENT_CLINICAL_MESSAGE:
    "O anexo será removido da análise clínica",
  CONFIRM_DELETE_WITNESS: "Tem certeza que deseja deletar a testemunha",
  CONFIRM_DELETE_WITNESS_MESSAGE:
    "Por favor, note que você não verá a testemunha novamente no sistema, mas iremos salvar uma cópia de seus dados",
  CONFIRM_DELETE_OFFICE: "Tem certeza que deseja excluir o escritório",
  CONFIRM_DELETE_OFFICE_MESSAGE:
    "Por favor, note que você não verá o escritório novamente, mas manteremos uma cópia de seus dados",
  CONFIRM_DELETE_STAGE: "Tem certeza que deseja deletar o estágio",
  CONFIRM_DELETE_STAGE_MESSAGE:
    "Por favor, note que você não verá o estágio novamente, mas manteremos uma cópia de seus dados",
  CONFIRM_DELETE_TECHNIQUE: "Tem certeza que deseja remover a técnica",
  CONFIRM_DELETE_TECHNIQUE_MESSAGE:
    "Por favor, note que você não verá a técnica novamente, mas vamos salvar uma cópia de seus dados",
  CONFIRM_FINALIZE_STUDIES: "Tem certeza que deseja terminar seus estudos",
  CONFIRM_FINALIZE_STUDIES_MESSAGE:
    "Um total de {{value}} estudos de paternidade serão concluídos",
  CONFIRM_FINALIZE_ANALYZES:
    "Tem certeza que deseja encerrar os análise clínicos",
  CONFIRM_FINALIZE_ANALYZES_MESSAGE:
    "Um total de {{value}} análise clínicos serão concluídos",
  CONFIRM_SEND_STUDIES_TO_OFFICE: "Tem certeza que deseja enviar estes estudos",
  CONFIRM_SEND_STUDIES_TO_OFFICE_MESSAGE:
    "Um total de {{value}} estudos de paternidade serão enviados para o escritório {{name}}",
  CONFIRM_SEND_ANALYZES_TO_OFFICE:
    "Tem certeza que deseja enviar estas análises",
  CONFIRM_SEND_ANALYZES_TO_OFFICE_MESSAGE:
    "Um total de {{value}} análises clínicas serão enviadas para o consultório {{name}}",
  CONFIRM_SEND_ANALYSIS_TO_OFFICE: "Tem certeza que deseja enviar esta análise",
  CONFIRM_SEND_ANALYSIS_TO_OFFICE_MESSAGE:
    "A análise será enviada para outro escritório",
  CONFIRM_RECEIVE_STUDIES: "Tem certeza que deseja aceitar estes estudos",
  CONFIRM_RECEIVE_STUDIES_MESSAGE:
    "Um total de {{value}} estudos de paternidade serão atribuídos ao seu escritório",
  CONFIRM_RECEIVE_ANALYZES: "Tem certeza que deseja aceitar estas análises",
  CONFIRM_RESULTS_ANALYZES: "Tem certeza de que confirma estes resultados",
  CONFIRM_IMPORT_ANALYZES:
    "Tem certeza de que confirma estes novos análises clínico/s",
  CONFIRM_IMPORT_GENETIC_PROFILES:
    "Tem certeza que confirma estes novos perfis genéticos",
  CONFIRM_IMPORT_PROSPECTS:
    "Tem certeza de que deseja confirmar esses novos clientes em potencial",
  CONFIRM_RECEIVE_ANALYZES_MESSAGE:
    "Um total de {{value}} testes clínicos serão atribuídos ao seu consultório",
  CONFIRM_DELETE_TYPES_ANALYSIS_CLINICAL:
    "Tem certeza que deseja excluir o tipo de análise clínica",
  CONFIRM_DELETE_TYPES_ANALYSIS_CLINICAL_MESSAGE:
    "Observe que você não verá o tipo de análise clínica novamente, mas manteremos uma cópia de seus dados",
  CONFIRM_DELETE_INDIVIDUAL: "Tem certeza que deseja excluir a pessoa",
  CONFIRM_DELETE_INDIVIDUAL_MESSAGE:
    "Por favor, note que você não verá seu log no sistema novamente, mas iremos salvar uma cópia de seus dados",
  CONFIRM_DELETE_USER: "Tem certeza que deseja deletar o usuário",
  CONFIRM_DELETE_USER_MESSAGE:
    "Lembre-se que este usuário não poderá entrar novamente no sistema, mesmo assim os dados que por ele modificados não serão eliminados e continuarão associados à sua conta",
  CONFIRM_DELETE_NURSE: "Tem certeza de que deseja excluir a enfermeira",
  CONFIRM_DELETE_NURSE_MESSAGE:
    "Tenha em atenção que este enfermeiro não poderá voltar a entrar no sistema, mesmo assim os dados por ele modificados não serão apagados e continuarão associados à sua conta.",
  CONFIRM_DELETE_ROLE: "Tem certeza que deseja deletar a função",
  CONFIRM_DELETE_ROLE_MESSAGE:
    "Por favor, note que você não verá mais esta função no sistema, mas manteremos uma cópia de seus dados",
  CONFIRM_DELETE_CLIENT: "Tem certeza que deseja excluir o cliente",
  CONFIRM_DELETE_CLIENT_MESSAGE:
    "Observe que você não verá mais este cliente no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_LOCATION: "Tem certeza de que deseja excluir o local",
  CONFIRM_DELETE_LOCATION_MESSAGE:
    "Observe que você não verá mais este local no sistema, mas salvaremos uma cópia dos seus dados",
  CONFIRM_DELETE_GENDER: "Tem certeza que deseja deletar o sexo biológico",
  CONFIRM_DELETE_GENDER_MESSAGE:
    "Observe que você não verá mais este sexo biológico no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_APPOINTMENT_SECTOR: "Tem certeza que deseja deletar o setor",
  CONFIRM_DELETE_APPOINTMENT_SECTOR_MESSAGE:
    "Observe que você não verá mais este setor no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_COORDINATION_TYPE:
    "Tem certeza que deseja deletar o tipo de coordenação",
  CONFIRM_DELETE_COORDINATION_TYPE_MESSAGE:
    "Observe que você não verá mais este tipo no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_SPECIALTY: "Está seguro de que desea eliminar la especialidad",
  CONFIRM_DELETE_SPECIALTY_MESSAGE:
    "Tenga en cuenta que você não verá esta especialidad en el sistema, pero guardaremos una copia de sus datos",
  CONFIRM_DELETE_DOCTOR: "Tem certeza que deseja excluir o médico",
  CONFIRM_DELETE_DOCTOR_MESSAGE:
    "Observe que você não verá mais o médico no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_COUNTRY: "Tem certeza que deseja deletar o país",
  CONFIRM_DELETE_COUNTRY_MESSAGE:
    "Observe que você não verá mais o país no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_KINSHIP: "Tem certeza de que deseja remover o relacionamento",
  CONFIRM_DELETE_KINSHIP_MESSAGE:
    "Observe que você não verá mais essa relação no sistema, mas manteremos uma cópia de seus dados",
  CONFIRM_DELETE_MEDICAL_INSTITUTION:
    "Tem certeza que deseja excluir a instituição médica",
  CONFIRM_DELETE_MEDICAL_INSTITUTION_MESSAGE:
    "Observe que você não verá mais esta instituição no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_PRODUCT: "Tem certeza que deseja remover o produto",
  CONFIRM_DELETE_PRODUCT_MESSAGE:
    "Observe que você não verá mais este produto no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_TYPES_PATERNITY_STUDY:
    "Tem certeza que deseja excluir o tipo de estudo de paternidade",
  CONFIRM_DELETE_TYPES_PATERNITY_STUDY_MESSAGE:
    "Por favor, note que você não verá a técnica novamente, mas vamos salvar uma cópia de seus dados",
  CONFIRM_DELETE_ETHNIC_ORIGIN: "Tem certeza que deseja remover a etnia",
  CONFIRM_DELETE_ETHNIC_ORIGIN_MESSAGE:
    "Por favor, note que você não verá mais esta etnia no sistema, mas iremos salvar uma cópia de seus dados",
  CONFIRM_DELETE_SAMPLE_TYPE: "Claro que deseja deletar o tipo de amostra",
  CONFIRM_DELETE_SAMPLE_TYPE_MESSAGE:
    "Observe que você não verá mais este tipo de amostra no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_DOCUMENT_TYPE:
    "Tem certeza que deseja deletar o tipo de documento",
  CONFIRM_DELETE_DOCUMENT_TYPE_MESSAGE:
    "Observe que você não verá mais este tipo de documento no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_MARKER: "Claro que deseja deletar o marcador genético",
  CONFIRM_DELETE_MARKER_MESSAGE:
    "Observe que você não verá mais este marcador genético no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_PROSPECT:
    "Você com certeza deseja excluir o cliente potencial",
  CONFIRM_DELETE_PROSPECT_MESSAGE:
    "Observe que você não verá mais este cliente em potencial no sistema, mas salvaremos uma cópia de seus dados",
  CONFIRM_DELETE_EXTRACTION_METHOD:
    "Claro que deseja remover o método de extração",
  CONFIRM_DELETE_EXTRACTION_METHOD_MESSAGE:
    "Observe que você não verá mais este método de extração no sistema, mas salvaremos uma cópia de seus dados",

  CONFIRM_PASSWORD_CHANGE: "Quer confirmar a mudança de senha",
  CONFIRM_PASSWORD_CHANGE_MESSAGE:
    "A senha do usuário será alterada e sua atribuição será encerrada, então ele terá que fazer o login novamente",

  SELECT_OFFICE_MESSAGE:
    "Selecione o escritório ao qual deseja associar os dados",

  GENERAL_SCHEDULER_PAGE_TITLE: "Agenda",
  SCHEDULER_VIEW_TYPE_DAY: "Dia",
  SCHEDULER_VIEW_TYPE_MONTH: "Mês",
  SCHEDULER_VIEW_TYPE_WEEK: "Semana",
  SCHEDULER_FORM_TITLE_LABEL: "Título",
  SCHEDULER_FORM_DESCRIPTION_LABEL: "Descrição",
  SCHEDULER_FORM_START_LABEL: "Data de início",
  SCHEDULER_FORM_END_LABEL: "Data final",
  SCHEDULER_FORM_TYPES_LABEL: "Tipo de compromisso",
  SCHEDULER_FORM_TITLE_ERROR_REQUIRED: "Título obrigatório",
  SCHEDULER_FORM_TITLE_ERROR_MAX_LENGTH:
    "O comprimento máximo do campo é:  {{max_length}}",
  SCHEDULER_FORM_DESCRIPTION_ERROR_MAX_LENGTH:
    "O comprimento máximo do campo é: {{max_length}}",
  SCHEDULER_DIALOG_TITLE: "Marcar consulta",
  SCHEDULER_FORM_NURSE_ERROR_REQUIRED: "Precisa-se de enfermeira",
  SCHEDULER_NO_COORDINATION_TYPES_WARNING: "Não há tipos de coordenação ativos no sistema. Eles são necessários para usar a agenda.",
  SCHEDULER_AGENDA_REPORT_DOWNLOAD: "Baixe o relatório de hoje",
  SCHEDULER_AGENDA_EMPTY: "Sem compromissos para hoje",
  SCHEDULER_AGENDA_CLINICAL_DATA_MAX_LENGTH: "Os dados clínicos podem ter até {{max_length}} caracteres",
  SCHEDULER_AGENDA_CLINICAL_DATA_LABEL: "Dados clínicos",
  SCHEDULER_AGENDA_DETAILS_MAX_LENGTH: "Os detalhes podem ter até {{max_length}} caracteres",
  SCHEDULER_AGENDA_DETAILS_LABEL: "Detalhes",
  APPOINTMENT_SECTOR_REQUIRED: "Setor de citação obrigatório",
  COORDINATION_EXTRACTION: "Coordenação de Extração",
  COORDINATION_EXTRACTION_REQUIRED: "A coordenação da extração é necessária",
  AGENDA_STATUS: 'Estado',
  AGENDA_STATUS_REQUIRED: 'Estado é obrigatório',
  AGENDA_REASON_FOR_CANCELLATION: 'Razão para cancelamento',
  AGENDA_REASON_FOR_CANCELLATION_MAX_LENGTH: "Razão para cancelamento podem ter até {{max_length}} caracteres",
  AGENDA_REASON_FOR_CANCELLATION_REQUIRED: "O motivo do cancelamento é obrigatório",
  AGENDA_INVALID_HOLDERS: "Portadores inválidos",
  AGENDA_REQUIRED_HOLDERS: "Portadores obrigatórios",
  AGENDA_HOLDER_VALIDATION_STATUS: "Válido",
  AGENDA_NEW: "nova cotação",
  AGENDA_SKIP_AND_GO_BACK: 'Pular e voltar ao Calendário',
  AGENDA_GO_BACK_TO_DETAILS: "Voltar ao detalhe",

  ADD_ATTACHMENT: "Novo anexo",
  PDF_LABEL: "Arquivo PDF",
  EXCEL_LABEL: "Arquivo Excel",
  WORD_LABEL: "Arquivo Word",
  PPT_LABEL: "Arquivo PowerPoint",
  XML_LABEL: "Arquivo XML",
  TXT_LABEL: "Arquivo de texto",
  IMAGE_LABEL: "Imagem",
  FILE_LABEL: "Arquivo",
  DROP_FILE_LABEL: "Clique aqui ou arraste os arquivos a serem carregados",
  DROP_FILE_LABEL_ACTIVE: "Soltar arquivos",
  DROP_FILE_ERROR_MESSAGE: "Ocorreu um erro ao processar o arquivo selecionado",
  DROP_FILE_MAX_FILES_EXCEED_ERROR_MESSAGE:
    "Você só pode fazer upload de 3 arquivos por vez",
  DROP_FILE_MAX_FILES_EXCEED_GROUP_ERROR_MESSAGE:
    "Você só pode fazer upload de um arquivo para atribuição de grupo",
  DROP_FILES_SUCCESS_MESSAGE: "Arquivos enviados com sucesso",
  DROP_FILE_SUCCESS_MESSAGE: "Arquivo carregado com sucesso",
  DROP_FILE_EMPTY_LIST: "Nenhum arquivo selecionado",
  DROP_FILE_EMPTY: "Nenhum arquivo selecionado",
  FILE_ACCEPTED: "Arquivo aceito",
  FILE_SIZE_EXCEED: "O arquivo excede 10 MB",
  FILE_PICTURE_SIZE_EXCEED: "A foto excede 10 MB",
  FILE_FOOTPRINT_1_SIZE_EXCEED: "Pegada 1 excede 10 MB",
  FILE_FOOTPRINT_2_SIZE_EXCEED: "Pegada 2 excede 10 MB",
  FILE_SIZE_EXCEED_MESSAGE: "Um arquivo excede 10 MB",
  FILE_NAME_DUPLICATED: "Nome de arquivo duplicado",
  SELECT_FILE: "Selecionar arquivo",
  STAGE_DUPLICATED: "Estágio duplicado",
  INDIVIDUAL_DUPLICATED: "O indivíduo já está em estudo de paternidade",
  STUDIES_EMPTY_LIST: "Nenhum estudo selecionado",
  CLINICAL_ANALYSIS_EMPTY_LIST: "Sin análises seleccionados",
  PROSPECTS_EMPTY_LIST: "Nenhum cliente potencial selecionado",
  EMPTY_TASKS: "Sem tarefas atribuídas",
  WAITING_FOR_DATA_IMPORT: "Aguardando importação de dados",
  //! Labels para referencias
  REFERENCE_SUCCESS: "Mais de 5 dias",
  REFERENCE_WARNING: "Entre 3 e 4 dias",
  REFERENCE_DANGER: "Menos de 2 dias",
  REFERENCE_IMPORT_SUCCESS: "Pronto para processar",
  REFERENCE_IMPORT_WARNING: "Ja tem resultado",
  REFERENCE_IMPORT_DANGER: "Nao encontrado",
  REFERENCE_IMPORT_INCORRECT: "Dados ausentes",
  REFERENCE_IMPORT_PROFILES_SUCCESS: "Pronto para processar",
  REFERENCE_IMPORT_PROFILES_WARNING: "Você já tem um perfil genético atribuído",
  REFERENCE_IMPORT_PROFILES_DANGER: "O indivíduo não foi encontrado",
  IMPORT_PROFILES_MESSAGE:
    "Apenas os perfis de indivíduos existentes serão associados",

  ANALYZES_RESULTS_PROCESS: "Um total de {{value}} análises serão atualizadas",
  ANALYZES_PROCESS: "Será adicionado um total de {{value}} análises clínicas",
  PROSPECTS_PROCESS:
    "Um total de {{value}} clientes em potencial será adicionado",
  NOTHING_PROCESS: "Nada para processar",
  GENETIC_PROFILES_PROCESS: "Um total de {{value}} perfis serão adicionados",

  INSTRUCTION_ENTER_TO_ADD: "Pressione ENTER para adicionar",
  INCORRECT_EMAIL_FORMAT: "Formato de email errado",

  INDIVIDUAL_NOT_FOUND: "Nenhum indivíduo encontrado",
  NO_VISITS_THAT_RANGE: "Nenhuma visita para esse intervalo de datas",
  DENIED_BY_ADMIN: "Acesso negado pelo administrador",

  METHOD_NOT_IMPLEMENTED: "Método não implementado",
  DEFAULT_MESSAGE_ERROR: "Ocorreu um erro, tente novamente mais tarde",
  LANGUAGE: "Língua",
  PT: "Português",
  ES: "Espanhol",
  EN: "Inglês",
  LOADING: "Carregando",
  PENDING_CHANGES_ACTION: "Há alterações não salvas",
  PENDING_CHANGES: "Há alterações não salvas"
};
